import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BgImage from '../../../images/front/footer/background.png';
import HomeImage from '../../../images/front/footer/home.png';
import TravelerImage from '../../../images/front/footer/traveler.png';
import { makeBackgroundImageStyles } from '../../core/styles';
import BottomContainer from './containers/BottomContainer';
import MapBlock from './MapBlock';
import AppContainer from '../Container/AppContainer';
import { APP_VIEW } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 100,
  },
  above: {
    marginTop: 0,
    marginRight: theme.spacing(5),
    marginLeft: theme.spacing(5),
    marginBottom: -2,
    position: 'relative',
    zIndex: 5,
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(10),
      marginLeft: theme.spacing(10),
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 'auto',
      marginLeft: 'auto',
      width: `calc(100% - ${theme.spacing(20)}px)`,
      maxWidth: `calc(${theme.breakpoints.values.lg}px - ${theme.spacing(
        40,
      )}px)`,
    },
  },
  img: {
    verticalAlign: 'middle',
    borderStyle: 'none',
    width: 'auto',
    height: 40,
  },
  background: {
    position: 'relative',
    zIndex: 10,
    ...makeBackgroundImageStyles(BgImage),
    backgroundPosition: 'unset',
  },
  container: {
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
  sns: {
    paddingTop: theme.spacing(4),
  },
}));

const Footer = (props: { classes?: Object }) => {
  const classes = useStyles(props);
  const appView = !window.location.pathname.includes(APP_VIEW);

  if (!appView) return null;

  return (
    <footer className={classes.root}>
      <div className={classes.above}>
        <img src={TravelerImage} className={classes.img} alt="travel" />
        <img
          src={HomeImage}
          className={classes.img}
          style={{ float: 'right' }}
          alt="home"
        />
      </div>
      <div className={classes.background}>
        <AppContainer classes={{ root: classes.container }}>
          <div>
            <MapBlock />
          </div>
          <div className={classes.sns}>
            <BottomContainer />
          </div>
        </AppContainer>
      </div>
    </footer>
  );
};

export default Footer;
